import React from 'react';
import { createPortal } from 'react-dom';
import Notif from './Notif';
const Modal = ({show,onClose})=>{
    const modal = show && <Notif onClose={onClose}/>
   return createPortal(modal,document.getElementById('modal'))
}
export default Modal